export default "__VITE_ASSET__BZuLT8cw__"